module.exports = __webpack_public_path__ + "img/B高通3.7ae5157c.png";